import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { UpgradeModule } from '@angular/upgrade/static';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgrxFormsModule } from 'ngrx-forms';
import { AdminCentralActions } from './state/admin-central.actions';
import { AdminCentralEffects } from './state/admin-central.effects';
import { AdminCentralReducer, STORE_FEATURE_KEY_ADMIN_CENTRAL } from './state/admin-central.reducer';
import { AdminCentralSelectors } from './state/admin-central.selectors';
import { AdminCentralService } from './state/admin-central.service';

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        UpgradeModule,
        FormsModule,
        NgrxFormsModule,
        ReactiveFormsModule,
        StoreModule.forFeature(STORE_FEATURE_KEY_ADMIN_CENTRAL, AdminCentralReducer),
        EffectsModule.forFeature([AdminCentralEffects])
    ],
    declarations: [
    ],
    providers: [
        AdminCentralSelectors,
        AdminCentralService,
        AdminCentralActions
    ]
})
export class AminCentralModule {
}
